import { render, staticRenderFns } from "./TasksBoardFiltersFast.vue?vue&type=template&id=78c550d2&"
import script from "./TasksBoardFiltersFast.vue?vue&type=script&lang=js&"
export * from "./TasksBoardFiltersFast.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports